/** Figma SP フレーム基準（393×852）。Mobile `assistant_cat_home_layout.dart` と同じ。 */
export const ASSISTANT_CAT_HOME_FIGMA_W = 393;
export const ASSISTANT_CAT_HOME_FIGMA_H = 852;
/** Web コンテンツ最大幅。SP 393 の約 1.5 倍 */
export const ASSISTANT_CAT_HOME_CONTENT_MAX_W = Math.round(ASSISTANT_CAT_HOME_FIGMA_W * 1.5);

export const ASSISTANT_CAT_HOME_FIGMA_ROOM_X = -22;
export const ASSISTANT_CAT_HOME_FIGMA_ROOM_Y = 144;
export const ASSISTANT_CAT_HOME_FIGMA_ROOM_SIZE = 432;
export const ASSISTANT_CAT_HOME_FIGMA_CAT_X = 46;
export const ASSISTANT_CAT_HOME_FIGMA_CAT_Y = 220;
export const ASSISTANT_CAT_HOME_FIGMA_CAT_W = 301;
export const ASSISTANT_CAT_HOME_FIGMA_CAT_H = 334;
export const ASSISTANT_CAT_HOME_FIGMA_BUBBLE_X = 16;
export const ASSISTANT_CAT_HOME_FIGMA_BUBBLE_Y = 72;
export const ASSISTANT_CAT_HOME_FIGMA_BUBBLE_W = 361;

export const ASSISTANT_CAT_HOME_HEADER_PADDING_TOP = 8;
export const ASSISTANT_CAT_HOME_HEADER_BUTTON_SIZE = 40;
export const ASSISTANT_CAT_HOME_GAP_HEADER_TO_BUBBLE = 16;
export const ASSISTANT_CAT_HOME_PANEL_RESERVE = 148;
export const ASSISTANT_CAT_HOME_MIN_SCALE = 0.5;
export const ASSISTANT_CAT_HOME_ACTION_BOTTOM = 16;

export interface AssistantCatHomeLayout {
  scale: number;
  originX: number;
  bubbleTop: number;
  bubbleLeft: number;
  bubbleW: number;
  roomSize: number;
  roomLeft: number;
  roomTop: number;
  catW: number;
  catH: number;
  catLeft: number;
  catTop: number;
  actionBottom: number;
}

/**
 * Mobile タブレットと同じ均一 scale。
 * Web はコンテンツ最大幅を SP の約 1.5 倍まで許可し、縦が足りないときだけ縮小する。
 */
export function resolveAssistantCatHomeLayout(size: { width: number; height: number }): AssistantCatHomeLayout {
  const width = Math.max(0, size.width);
  const height = Math.max(0, size.height);
  const bubbleTop =
    ASSISTANT_CAT_HOME_HEADER_PADDING_TOP +
    ASSISTANT_CAT_HOME_HEADER_BUTTON_SIZE +
    ASSISTANT_CAT_HOME_GAP_HEADER_TO_BUBBLE;

  const maxRoomBottom = height - ASSISTANT_CAT_HOME_ACTION_BOTTOM - ASSISTANT_CAT_HOME_PANEL_RESERVE;
  const stageW = Math.min(width, ASSISTANT_CAT_HOME_CONTENT_MAX_W);
  let scale = stageW / ASSISTANT_CAT_HOME_FIGMA_W;

  const roomSpan =
    ASSISTANT_CAT_HOME_FIGMA_ROOM_SIZE +
    (ASSISTANT_CAT_HOME_FIGMA_ROOM_Y - ASSISTANT_CAT_HOME_FIGMA_BUBBLE_Y);
  const available = maxRoomBottom - bubbleTop;
  if (available > 0) {
    scale = Math.min(scale, available / roomSpan);
  }
  scale = Math.max(scale, ASSISTANT_CAT_HOME_MIN_SCALE);

  const contentW = ASSISTANT_CAT_HOME_FIGMA_W * scale;
  const originX = (width - contentW) / 2;
  const artwork = centerArtwork(
    { width, height },
    scale,
    bubbleTop,
    height - ASSISTANT_CAT_HOME_ACTION_BOTTOM - ASSISTANT_CAT_HOME_PANEL_RESERVE,
  );

  return {
    scale,
    originX,
    bubbleTop,
    bubbleLeft: originX + ASSISTANT_CAT_HOME_FIGMA_BUBBLE_X * scale,
    bubbleW: ASSISTANT_CAT_HOME_FIGMA_BUBBLE_W * scale,
    ...artwork,
    actionBottom: ASSISTANT_CAT_HOME_ACTION_BOTTOM,
  };
}

const CAT_OFFSET_X = ASSISTANT_CAT_HOME_FIGMA_CAT_X - ASSISTANT_CAT_HOME_FIGMA_ROOM_X;
const CAT_OFFSET_Y = ASSISTANT_CAT_HOME_FIGMA_CAT_Y - ASSISTANT_CAT_HOME_FIGMA_ROOM_Y;
const BUBBLE_RESERVE = 112;

function centerArtwork(
  size: { width: number; height: number },
  scale: number,
  bubbleTop: number,
  bottomBound: number,
): Pick<AssistantCatHomeLayout, "roomSize" | "roomLeft" | "roomTop" | "catW" | "catH" | "catLeft" | "catTop"> {
  const roomSize = ASSISTANT_CAT_HOME_FIGMA_ROOM_SIZE * scale;
  const topBound = bubbleTop + BUBBLE_RESERVE;
  const available = bottomBound - topBound;
  const roomTop = topBound + Math.max(0, available - roomSize) / 2;

  return {
    roomSize,
    roomLeft: (size.width - roomSize) / 2,
    roomTop,
    catW: ASSISTANT_CAT_HOME_FIGMA_CAT_W * scale,
    catH: ASSISTANT_CAT_HOME_FIGMA_CAT_H * scale,
    catLeft: (size.width - roomSize) / 2 + CAT_OFFSET_X * scale,
    catTop: roomTop + CAT_OFFSET_Y * scale,
  };
}

export function layoutBoxStyle(left: number, top: number, width: number, height?: number): Record<string, string> {
  const style: Record<string, string> = {
    left: `${left}px`,
    top: `${top}px`,
    width: `${width}px`,
  };
  if (height !== undefined) {
    style.height = `${height}px`;
  }
  return style;
}
